import axios from "axios";
import { identityApi } from "@ba/visary-account-common-vue"
import Locale from "@/utils/locale";
import { setLocale } from "@/utils/i18n"

export default async function setup() {
  const launchConfig = await fetchLaunchConfig();

  Locale.setLocale(launchConfig.locale || Locale.DEFAULT)
  setLocale(Locale.current.language)

  if (launchConfig.identityApiBaseUrl) {
    identityApi.configure(launchConfig.identityApiBaseUrl)
  }
}

async function fetchLaunchConfig(cancelToken = null) {
  const prodUrl = "/config/app.json"
  const devUrl = "/config/app.local.json"

  if (process.env.NODE_ENV === "production") {
    return (await axios.get(prodUrl, { cancelToken })).data;
  } else {
    try {
      return (await axios.get(devUrl, { cancelToken })).data;
    } catch (e) {
      return (await axios.get(prodUrl, { cancelToken })).data;
    }
  }
}
